import { FunctionComponent, useContext } from 'react'
import Link from 'next/link'
import { CampaignContext } from '../src/state/CampaignContext'
import iconUsaMade from '~public/images/icon-usa-made.svg'
import iconSweatshopFree from '~public/images/icon-sweatshop-free.svg'

export const ProductDetails: FunctionComponent = () => {
  const campaign = useContext(CampaignContext)
  const { offer, artist, cause } = campaign

  return (
    <div className="stack-l gap-s1">
      <p>{offer.description}</p>
      <p>
        Design by {artist.name} | Benefiting {cause.name}
      </p>

      <p>
        Ethically sourced & responsibly screen printed
        <br />
        USA Made
      </p>

      <div className="flex flex-wrap gap-s_2">
        <img src={iconUsaMade.src} alt="USA Made" />
        <img src={iconSweatshopFree.src} alt="Sweatshop Free" />
      </div>

      <p className="with-links">
        Have a question?{' '}
        <a href="mailto:support@swagleft.com">Drop us a line.</a>
        <br />
        Check out our{' '}
        <Link href="/faq" passHref>
          Return Policy.
        </Link>
      </p>
    </div>
  )
}
